module.exports = __webpack_public_path__ + "static/image3-cde41bee3b5d067d2455bd82509f7f69.png";